import gql from 'graphql-tag';
export const turnOnSmsTwoFAMutation = gql `
  mutation TurnOnSms2FA($record: ToggleSms2FARecord!) {
    turnOnSms2FA(record: $record)
  }
`;
export const turnOffSmsTwoFAMutation = gql `
  mutation TurnOffSms2FA($record: ToggleSms2FARecord!) {
    turnOffSms2FA(record: $record)
  }
`;
export const turnOnGoogleTwoFAMutation = gql `
  mutation TurnOnGoogleFA($record: ToggleSms2FARecord!) {
    turnOnGoogle2FA(record: $record)
  }
`;
export const turnOffGoogleTwoFAMutation = gql `
  mutation TurnOffGoogleFA($record: ToggleSms2FARecord!) {
    turnOffGoogle2FA(record: $record)
  }
`;
//# sourceMappingURL=toggle2FA.js.map